/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';

export default class Return extends Route {
  beforeModel(transition: Transition) {
    transition.abort();
    let platformAndChannel = transition.from?.parent?.params;
    this.replaceWith('apps.app.standalone.deploy.channel', platformAndChannel);
  }
}
